<template>
  <div>
    <b-row class="m-0">
      <b-col cols="12" md="12" class="mb-2 border-top">
        <div
          v-if="pathOr(false, ['standardized_interview_score'], specialtyData)"
          class="showInChart"
          :style="{
            left:
              pathOr(0, ['standardized_interview_score'], specialtyData) -
              2 +
              `%`,
            bottom: `53%`,
          }"
        >
          <div class="line-chart"></div>
        </div>
        <barChart
          :title="$lang.tabTwoChartTitle"
          :labelChart="labelChart"
          :backgroundColor="backgroundColor"
          :data="dataBar"
        />
      </b-col>
      <b-col cols="12" md="6" class="my-2">
        <div class="bg-light rounded p-3">
          <chartTable
            :title="$lang.finalReportInterviewSummarizeTitleRight"
            :items="pathOr([], ['interview_summarize'], specialtyData)"
          />
        </div>
      </b-col>
      <b-col cols="12" md="6" class="my-2">
        <div class="bg-light rounded p-3">
          <scoreTable
            :title="$lang.finalReportInterviewSummarizeTitleLeft"
            :fields="enteringAzmoonFields"
            :items="[pathOr([], ['entering_azmoon'], specialtyData)]"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { pathOr } from "ramda";
import barChart from "@/components/chart/barChart.js";
import chartTable from "./chartTable.vue";
import scoreTable from "./scoreTable.vue";
export default {
  components: {
    barChart,
    chartTable,
    scoreTable,
  },
  data() {
    return {
      backgroundColor: [
        "#ff0000",
        "#ff0000",
        "#ff0000",
        "#ff0000",
        "#ff0000",
        "#ff0000",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#28a745f2",
        "#28a745f2",
        "#28a745f2",
        "#28a745f2",
        "#28a745f2",
        "#28a745f2",
        "#28a745f2",
        "#28a745f2",
      ],
      dataBar: [
        2, 6, 11, 20, 40, 89, 112, 179, 215, 264, 282, 260, 222, 153, 84, 47,
        20, 8, 3, 0,
      ],
      labelChart: [
        0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65,
        0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1,
      ],
      code: this.$route.params.code,
      specialtyData: {},
      enteringAzmoonFields: [
        {
          key: "level",
          label: "نمره تراز",
          class: "text-center",
          thClass: "bg-info text-center p-1",
          tdClass: "p-1 text-muted",
        },
        {
          key: "rank",
          label: "رتبه در سهمیه",
          class: "text-center",
          thClass: "bg-info text-center p-1",
          tdClass: "p-1 text-muted",
        },
        {
          key: "sacrificer_type",
          label: "نوع سهمیه",
          class: "text-center",
          thClass: "bg-info text-center p-1",
          tdClass: "p-1 text-muted",
        },
        {
          key: "hoze_ghazaei_location_caption",
          label: "حوزه قضایی پذیرفته شده",
          class: "text-center",
          thClass: "bg-info text-center p-1",
          tdClass: "p-1 text-muted",
        },
      ],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    async fetchData() {
      try {
        this.$emit("setLoading", true);
        const url =
          this.$config.api_url +
          this.$config.report.final_report_specialty.replace("{0}", this.code);

        const response = await this.$httpService.get(url);
        this.specialtyData = {
          ...pathOr({}, ["data", "data"], response),
        };
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.$emit("setLoading", false);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.showInChart {
  position: absolute;
}

.line-chart {
  background-color: springgreen;
  width: 10px;
  height: 30px;
  position: relative;

  &::after {
    bottom: -16px;
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 17px solid springgreen;
    right: -5px;
  }
}

.score_competency_table {
  tr {
    background-color: #fff !important;
  }
}
</style>
